import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=29421324&scoped=true"
import script from "./Infographic.vue?vue&type=script&lang=js"
export * from "./Infographic.vue?vue&type=script&lang=js"
import style0 from "./Infographic.vue?vue&type=style&index=0&id=29421324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29421324",
  null
  
)

export default component.exports